import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { loadPartners, Partner } from '@qwealth/qdata';
import { RootState } from 'data/store';
import { useDispatchOnMount } from '@qwealth/qcore';

export type PartnerMap = { [key: number]: Partner };

export const usePartnerMap = (): PartnerMap => {
  const { initialized: initializedPartnerList, partnerList } = useSelector(
    (state: RootState) => state.partners,
  );
  useDispatchOnMount(loadPartners, initializedPartnerList ? undefined : true);

  const [partnerMap, setPartnerMap] = useState<PartnerMap>({});
  useEffect(() => {
    const map = {};
    partnerList.forEach(i => (map[i.id!] = i));
    setPartnerMap(map);
  }, [partnerList]);

  return partnerMap;
};

export const usePartnerShortCodeMap = (): { [key: string]: Partner } => {
  const { initialized: initializedPartnerList, partnerList } = useSelector(
    (state: RootState) => state.partners,
  );
  useDispatchOnMount(loadPartners, initializedPartnerList ? undefined : true);

  const [partnerMap, setPartnerMap] = useState<PartnerMap>({});
  useEffect(() => {
    const map = {};
    partnerList.forEach(i => (map[i.partnerShortCode] = i));
    setPartnerMap(map);
  }, [partnerList]);

  return partnerMap;
};
